import React, { useState } from "react";
import {
  List,
  useTable,
  EditButton,
  DeleteButton,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";

export const BalanceList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const rows = tableProps.dataSource?.map((row) => ({
    ...row,
    id: row.bybit_subscription_id + row.snapped_at,
  }));

  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "bybit_subscription_id",
        title: "Bybit-subscription Id",
        type: "number",
        width: 160,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "snapped_at",
        title: "Snapped At",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "asset",
        title: "Asset",
        width: 80,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "equity",
        title: "Equity",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "available_balance",
        title: "Available Balance",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "used_margin",
        title: "Used Margin",
        type: "number",
        width: 120,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "order_margin",
        title: "Order Margin",
        type: "number",
        width: 120,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "position_margin",
        title: "Position Margin",
        type: "number",
        width: 120,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "occ_closing_fee",
        title: "Occ Closing Fee",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "occ_funding_fee",
        title: "Occ Funding Fee",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "wallet_balance",
        title: "Wallet Balance",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "realised_pnl",
        title: "Realised Pnl",
        type: "number",
        width: 120,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "unrealised_pnl",
        title: "Unrealised Pnl",
        type: "number",
        width: 120,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "cum_realised_pnl",
        title: "Cum Realised Pnl",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "given_cash",
        title: "Given Cash",
        type: "number",
        width: 120,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "service_cash",
        title: "Service Cash",
        type: "number",
        width: 120,
        align: "center",
        headerAlign: "center",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        dataSource={rows}
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
